const cv = window.cv;

export class SinglePoseUtil {
  static LEFT_FOOT_IDX = 31;
  static RIGHT_FOOT_IDX = 32;
  static LEFT_ANKLE_IDX = 27;
  static RIGHT_ANKLE_IDX = 28;

  static persons_detected(poses) {
    if (!poses || poses.length === 0) {
      return false;
    }
    return true;
  }

  static is_everyone_behind_start_point(poses, calibration) {
    if (!SinglePoseUtil.persons_detected(poses)) {
      return false;
    }

    return SinglePoseUtil.is_everyone_behind_the_point(
      poses,
      calibration.start_point_cv,
      calibration
    );
  }

  static is_everyone_behind_the_point(poses, point, calibration) {
    if (!SinglePoseUtil.persons_detected(poses)) {
      return false;
    }

    for (let person of poses) {
      let left_ankle = person.keypoints[SinglePoseUtil.LEFT_FOOT_IDX];
      let right_ankle = person.keypoints[SinglePoseUtil.RIGHT_FOOT_IDX];
      let warped_left_ankle = calibration.get_birds_eye_view_point(left_ankle);
      let warped_right_ankle =
        calibration.get_birds_eye_view_point(right_ankle);

      if (left_ankle.y > point.y || right_ankle.y > point.y) {
        return false;
      }
    }
    return true;
  }

  static has_someone_crossed_start_line(poses, calibration) {
    if (!SinglePoseUtil.persons_detected(poses)) {
      return false;
    }

    return !SinglePoseUtil.is_everyone_behind_start_point(poses, calibration);
  }

  static has_someone_crossed_finish_line(poses, calibration) {
    if (!SinglePoseUtil.persons_detected(poses)) {
      return false;
    }

    return !SinglePoseUtil.is_everyone_behind_the_point(
      poses,
      calibration.stop_point_cv,
      calibration
    );
  }

  static is_someone_in_box(
    poses,
    patient_feet_box_x,
    patient_feet_box_y,
    camera
  ) {
    if (!SinglePoseUtil.persons_detected(poses)) {
      return false;
    }
    for (let person of poses) {
      let left_foot = person.keypoints[SinglePoseUtil.LEFT_FOOT_IDX];
      let right_foot = person.keypoints[SinglePoseUtil.RIGHT_FOOT_IDX];
      let left_foot_x = camera.scale_to_fit({ x: left_foot.x, y: 0 }).x;
      let right_foot_x = camera.scale_to_fit({ x: right_foot.x, y: 0 }).x;
      if (
        right_foot_x > patient_feet_box_x[0] &&
        left_foot_x < patient_feet_box_x[1] &&
        right_foot.y > patient_feet_box_y[0] &&
        left_foot.y < patient_feet_box_y[1]
      ) {
        return true;
      }
    }
    return false;
  }
}
